export default __webpack_public_path__ + "static/media/Member17.3f1b0437.png";